var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { AwesomeEvent, ComponentAPI } from '@philips-internal/oswald-ui-core';
import { AbortableCloseEventListener, AbortableDeleteEventListener, CloseEventListener, DeleteEventListener, DownloadEventListener, OpenEventListener, PrintEventListener, SwapEventListener, ZoomEventListener } from '@philips-internal/oswald-ui-core/lib/component/types/index.js';
class MediaContainerAPI extends ComponentAPI {
    constructor() {
        super(...arguments);
        /**@event */
        this.onBeforeClose = new AbortableCloseEventListener();
        /** @event */
        this.onClose = new CloseEventListener();
        /** @event */
        this.onBeforeDelete = new AbortableDeleteEventListener();
        /** @event */
        this.onDelete = new DeleteEventListener();
        /** @event */
        this.onDownload = new DownloadEventListener();
        /**@event */
        this.onOpen = new OpenEventListener();
        /** @event */
        this.onPrint = new PrintEventListener();
        /** @event */
        this.onResetZoom = new ZoomEventListener();
        /** @event */
        this.onSwap = new SwapEventListener();
        /** @event */
        this.onZoomIn = new ZoomEventListener();
        /** @event */
        this.onZoomOut = new ZoomEventListener();
    }
    getData() {
        return this.state.data;
    }
    setData(data) {
        this.setState({ data });
    }
    isDeleteOptionEnabled() {
        return this.state.deleteOptionEnabled;
    }
    setDeleteOptionEnabled(deleteOptionEnabled) {
        this.setState({ deleteOptionEnabled });
    }
    isDownloadOptionEnabled() {
        return this.state.downloadOptionEnabled;
    }
    setDownloadOptionEnabled(downloadOptionEnabled) {
        this.setState({ downloadOptionEnabled });
    }
    getMode() {
        return this.state.mode;
    }
    setMode(mode) {
        return this.setState({ mode });
    }
    isOpen() {
        return this.state.open;
    }
    open() {
        if (this.isOpen()) {
            return;
        }
        this.setState({ open: true });
        this.onOpen.fire();
    }
    getTitle() {
        return this.state.title;
    }
    setTitle(title) {
        return this.setState({ title });
    }
    isPrintOptionEnabled() {
        return this.state.printOptionEnabled;
    }
    setPrintOptionEnabled(printOptionEnabled) {
        this.setState({ printOptionEnabled });
    }
}
__decorate([
    AwesomeEvent,
    __metadata("design:type", Object)
], MediaContainerAPI.prototype, "onBeforeClose", void 0);
__decorate([
    AwesomeEvent,
    __metadata("design:type", Object)
], MediaContainerAPI.prototype, "onClose", void 0);
__decorate([
    AwesomeEvent,
    __metadata("design:type", Object)
], MediaContainerAPI.prototype, "onBeforeDelete", void 0);
__decorate([
    AwesomeEvent,
    __metadata("design:type", Object)
], MediaContainerAPI.prototype, "onDelete", void 0);
__decorate([
    AwesomeEvent,
    __metadata("design:type", Object)
], MediaContainerAPI.prototype, "onDownload", void 0);
__decorate([
    AwesomeEvent,
    __metadata("design:type", Object)
], MediaContainerAPI.prototype, "onOpen", void 0);
__decorate([
    AwesomeEvent,
    __metadata("design:type", Object)
], MediaContainerAPI.prototype, "onPrint", void 0);
__decorate([
    AwesomeEvent,
    __metadata("design:type", Object)
], MediaContainerAPI.prototype, "onResetZoom", void 0);
__decorate([
    AwesomeEvent,
    __metadata("design:type", Object)
], MediaContainerAPI.prototype, "onSwap", void 0);
__decorate([
    AwesomeEvent,
    __metadata("design:type", Object)
], MediaContainerAPI.prototype, "onZoomIn", void 0);
__decorate([
    AwesomeEvent,
    __metadata("design:type", Object)
], MediaContainerAPI.prototype, "onZoomOut", void 0);
export default MediaContainerAPI;
//# sourceMappingURL=media-container-api.js.map